import styled from 'styled-components';
import type { ReactNode } from 'react';

import { media } from 'helpers/breakpoints';
import { space } from 'helpers/genericStyles';
import type { ISpace } from 'helpers/genericStyles';

interface IPanel extends ISpace {
  children: ReactNode;
  testId?: string;
  className?: string;
}

export const Wrapper = styled.div`
  ${space};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: ${({ theme }) => theme.spacing.M24};
  padding: ${({ theme }) => `${theme.spacing.M16}`};
  background: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  z-index: 1;

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
  }

  & > * {
    grid-column: 1 / 3;
  }

  .half {
    grid-column: auto;
  }

  .medium-half {
    ${media.medium} {
      grid-column: auto;
    }
  }

  .large-half {
    ${media.large} {
      grid-column: auto;
    }
  }
`;

function Panel({ children, testId, className, ...spaceProps }: IPanel) {
  return (
    <Wrapper className={className} data-testid={testId} {...spaceProps}>
      {children}
    </Wrapper>
  );
}

export { Panel };
